import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
// import { StoreService }  from '../../shared/store/store.service';
import { RemoteHostsService } from '../../shared/remote-hosts/remote-hosts.service';
// import { CognitoAuthService } from '../../shared/auth/cognito.service';

declare const _;

@Component({
    selector: 'remote-hosts-table',
    templateUrl: './remote-hosts-table.component.html',
    styleUrls: ['./remote-hosts-table.component.css']
})
export class RemoteHostsTableComponent implements OnInit {

    @Input() deviceIP = '';

    remoteHosts: any[ ] = [];
    remoteHostsParams: any[ ] = [
        {
            timePeriod: 'a', 
            ip: null, 
            param3: null, 
        }, 
        { 
            timePeriod: 'h',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'd',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'w',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'm',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'q',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'y',
            ip: null,
            param3: null,
        }
    ];

    timePeriods = ['a', 'h', 'd', 'w', 'm', 'q', 'y']; 
    timePeriodIndex = 1; 

    isDataLoading = true;
    isDataError = false;

    sortByFields = [['remote_ip'], ['last_seen', 'remote_ip'], ['sessions', 'remote_ip'], ['duration', 'remote_ip'], ['sent_bytes', 'remote_ip'], ['recv_bytes', 'remote_ip']];
    sortIndex = 0;
    sortAscending = false;

    constructor(private router: Router, private remoteHostsService: RemoteHostsService) {
    }

    ngOnInit() {
        this.changeTimePeriod('h');
    }

    refresh(silent = true) {
        this.getRemoteHosts(this.timePeriodIndex, true, silent);
    }

    getRemoteHosts(paramsIndex, forceFetchRemoteHostsFromAPI = false, silent = false) {

        const self = this;

        if (!silent) {
            self.isDataLoading = true;
        }

        const params = self.remoteHostsParams[paramsIndex];
        // inject the IP quietly here
        if (this.deviceIP) {
            params.ip = this.deviceIP;
        }

        self.remoteHostsService.getRemoteHosts(params).subscribe(function (remoteHosts) {

            self.remoteHosts = remoteHosts;
            // self.store.update('events', events);
            self.isDataLoading = false;
            self.isDataError = false;

            // console.dir(self.events);

        }, function (err) {

            console.log('Error in getting events. Called from events-table.component.ts');
            console.log(err);

        });

    }

    sortBy(i) {

        // console.log('Sorting alerts by ', this.sortByFields[i], '...');

        if (this.sortIndex === i) {
            this.sortAscending = !this.sortAscending;
        } else {
            this.sortAscending = false;
        }

        this.sortIndex = i;
        this.remoteHosts = _.sortBy(this.remoteHosts, this.sortByFields[i]);
        if (!this.sortAscending) {
            this.remoteHosts = _.reverse(this.remoteHosts);
        }
    }

    changeTimePeriod(t) {
        const index = this.timePeriods.indexOf(t);
        if (index > -1) {
            this.timePeriodIndex = index;
            this.getRemoteHosts(index);
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/remote-hosts-table/remote-hosts-table.component.ts